export const UPDATE = 'bodyMeasures/update';
export const ADD_MEASURES = 'bodyMeasures/addMeasures';
